import clsx from "clsx";
import React from "react";
import { ReactNode } from "react";

interface SettingRowProps {
  label?: string;
  value: ReactNode | ReactNode[];
  description?: string;
  additionalContent?: ReactNode;
  valueContainerClassName?: string;
  classes?: string;
}

export function SingleLineSettingRow({ label, value, description, additionalContent, valueContainerClassName, classes }: SettingRowProps) {
  return (
    <li className={`pl-3 pr-4 py-3 flex flex-col text-sm ${classes}`}>
      <div className="flex items-center justify-between">
        <div className="flex-1 flex flex-col items-start">
          <p className="text-sm font-medium text-etpink-600 w-full">
            {label}
          </p>
          {description && (
            <p className="text-xs font-light text-gray-700 w-full">
              {description}
            </p>
          )}
        </div>
        <div className={`ml-4 w-1/3 flex-shrink-0 flex justify-end items-center ${valueContainerClassName}`}>
          {value}
        </div>
      </div>
      {additionalContent && (
        <div className="mt-2 w-full block">
          {additionalContent}
        </div>
      )}
    </li>
  );
}

export function MultiLineSettingRow({ label, value, description, classes }: SettingRowProps) {
  return (
    <li className={`pl-3 pr-4 py-3 text-sm ${classes}`}>
      {label || description ? (
        <div className="flex-1 flex flex-col items-start">
          {label && (
            <p className="text-sm font-medium text-etpink-600 w-full">
              {label}
            </p>
          )}
          {description && (
            <p className="text-xs font-light text-gray-700 w-full">
              {description}
            </p>
          )}
        </div>
      ) : <></>}
      <div className={clsx(label || description ? "mt-3" : "")}>
        {value}
      </div>
    </li>
  );
}